var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1208 12C15.5087 12 15.8256 11.7046 15.7993 11.3416C15.663 9.46098 14.9463 7.68747 13.7663 6.34315C12.4493 4.84285 10.6632 4 8.80078 4C6.93836 4 5.15222 4.84285 3.83528 6.34315C2.65525 7.68747 1.93857 9.46097 1.80231 11.3416C1.77601 11.7046 2.0929 12 2.48073 12C2.86856 12 3.17983 11.7045 3.21272 11.3419C3.34476 9.88634 3.91188 8.51862 4.82838 7.47452C5.88193 6.27428 7.31084 5.6 8.80078 5.6C10.2907 5.6 11.7196 6.27428 12.7732 7.47452C13.6897 8.51862 14.2568 9.88634 14.3888 11.3419C14.4217 11.7045 14.733 12 15.1208 12Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArch);
export default __webpack_public_path__ + "static/media/arch.876cad6c7d4b98c1b13562a2bc8a727b.svg";
export { ForwardRef as ReactComponent };